import React, { useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { formatDateTime, mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams(
      { produtoNome: "", exibirInativos: false, exibirProdutosInativos: false },
      location
    )
  );
  const [promocoes, setPromocoes] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);
    api.get("promocoes/listar", filtrosEnviar).then((res) => {
      res.forEach((p) => {
        p.inicio = p.inicio ? formatDateTime(p.inicio, "D/M/Y") : "-";
        p.fim = p.fim ? formatDateTime(p.fim, "D/M/Y") : "-";
        p.valor = p.valorCentavos
          ? `Produto por R$ ${(p.valorCentavos / 100).toFixed(2)}`
          : `${p.pctDesconto}% de desconto`;
      });
      setPromocoes(res);
      setCarregando(false);
    });
  };

  const filtros = {
    title: "Filtros",
    form: {
      produtoNome: {
        label: "Produto",
        type: "text",
        space: 4,
        value: dados.nome,
      },
      exibirInativos: {
        type: "check",
        label: "Exibir inativas",
        space: 4,
        value: dados.exibirInativos,
      },
      exibirProdutosInativos: {
        type: "check",
        label: "Exibir produtos com registro inativo",
        space: 4,
        value: dados.exibirProdutosInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const table = {
    title: "Promoções",
    array: promocoes,
    columns: [
      {
        name: "produtoNome",
        label: "Produto",
      },
      {
        name: "inicio",
        label: "Início",
      },
      {
        name: "fim",
        label: "Fim",
      },
      {
        name: "valor",
        label: "Valor",
      },
    ],
    key: "id",
    newItemAction: () => history.push("/app/promocao/0"),
    onLineClick: (id) => history.push(`/app/promocao/${id}`),
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? <CircularProgress /> : <ActionTable structure={table} />}
    </div>
  );
}
